import { REVISAO } from "../nova-obra.constants";

export const textoOuTraco = (texto: string | null | undefined) => texto?.trim() || REVISAO.vazio;
